import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn, getStudent } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue'), meta: { public: true, title: '学生登录' } },
  { path: '/payment', component: () => import('@/views/Payment.vue'), meta: { title: '预订单支付' } },
  { path: '/pay_success', component: () => import('@/views/PaySuccess.vue'), meta: { public: true, title: '支付成功' } },
  { path: '/home', component: () => import('@/views/Home.vue'), meta: { title: '学生首页' } },
  { path: '/schedule', component: () => import('@/views/Schedule.vue'), meta: { title: '我的课表' } },
  { path: '/exam', component: () => import('@/views/Exam.vue'), meta: { title: '我的考试' } },
  { path: '/knowledge-qa', component: () => import('@/views/KnowledgeQa.vue'), meta: { title: '知识问答' } },
  { path: '*', redirect: '/login' }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - YanQue Student` : 'YanQue Student'
  if (to.meta.public) {
    if (to.path === '/login' && isLoggedIn()) {
      const student = getStudent()
      next(student && student.status === 'TEMPORARY' ? '/payment' : '/home')
      return
    }
    next()
    return
  }
  if (!isLoggedIn()) {
    next('/login')
    return
  }
  const student = getStudent()
  if (student && student.status === 'TEMPORARY' && !['/payment', '/pay_success'].includes(to.path)) {
    next('/payment')
    return
  }
  if (student && student.status !== 'TEMPORARY' && to.path === '/payment') {
    next('/home')
    return
  }
  next()
})

export default router

